import { render, staticRenderFns } from "./personal-references.vue?vue&type=template&id=247f51d0&"
import script from "./personal-references.vue?vue&type=script&lang=js&"
export * from "./personal-references.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports